import {
	Component,
	OnInit,
	Input,
	SimpleChange,
	OnChanges,
	AfterViewInit,
	Output,
	EventEmitter,
	ViewChild,
	ElementRef,
} from "@angular/core";
import { StateSpecificContentModelService } from "../../../models/state-specific-content-model.service";
import { CoursePage } from "../../../vo/course-page";
import { Subscription } from "rxjs";
import { DescriptorModelService } from "../../../models/descriptor-model.service";
import { AppServices } from "app/app.services";
import { ConfigDocModelService } from "app/core/models/config-doc-model.service";
import { ApplicationModel } from "app/core/models/application.model";
import { UtilityScripts } from "../../../../helpers/utility-scripts";

@Component({
	selector: "app-state-specific-content-adaptive",
	templateUrl: "./state-specific-content.adaptive.component.html",
	styleUrls: ["./state-specific-content.adaptive.component.scss"],
})
export class StateSpecificContentAdaptiveComponent implements AfterViewInit {
  @Input() coursePage: CoursePage;
  @Output() contentUpdateEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() opencloseEvent: EventEmitter<Object> = new EventEmitter(); 
  @Output() showStateContent = new EventEmitter<boolean>();
  @ViewChild('closestate') closestate: ElementRef;
  public descriptorService: DescriptorModelService;  
  private thumbnailImg: string;
  private serviceSubsriber: Subscription;
  @Input() bShowContent?: boolean = false;
  protected _stateContent:any;
  protected bShowStateSpecificIcon:boolean;
  public stateContent:any;
  public textDirection: string;
  public textAlign: string;

	constructor(
		private stateContentModel: StateSpecificContentModelService,
		private configDocModel: ConfigDocModelService,
		private descriptorModel: DescriptorModelService,
		private appService: AppServices
	) {
		this.textDirection = ApplicationModel.instance.flowDirection;
		this.textAlign = ApplicationModel.instance.textDirection;
	}

	public ngOnChanges(changes: SimpleChange) {
		//this.contentUpdateEvent.emit(this.stateContentModel.bShowStateSpecificIcon);
	}

	ngAfterViewInit() {
		this.contentUpdateEvent.emit(this.stateContentModel.bShowStateSpecificIcon);
	}

	private openHandler() {
		let strBody: string = "";
		let clickStateId: string = "";
		this.stateContentVal.content.forEach((element) => {
			if (element.heading !== "&nbsp;") {
				strBody += "<h4> <b>" + element.heading + "</b> </h4> ";
			}
			strBody += element.content;
			clickStateId = element.id;
		});
		this.stateContent = {
			title: this.stateContentVal.selected_state_label,
			bodyText: strBody,
		};
		this.appService.stateSpecificButtonClickHandler(
			this.coursePage.state_specific_content
		);
		this.stateContentModel.updateStateContent(clickStateId);
		this.bShowContent = true;
		this.opencloseEvent.emit({ isHandlerOpen: true });
		setTimeout(() => {
			if (this.closestate && this.bShowContent) {
				this.closestate.nativeElement.focus();
			}
		}, 10);
	}
	private closeHandler() {
		this.bShowContent = false;
		this.opencloseEvent.emit({ isHandlerOpen: false });
	}
	public get stateContentVal () {
		return this._stateContent = this.stateContentModel.stateContent;  
	}
	public set stateContentVal(val: any) {
		this._stateContent = this.stateContentModel.stateContent = val;
	}
	public get showStateSpecificIcon() {
		this.showStateContent.emit(this.stateContentModel.bShowStateSpecificIcon);
		return this.bShowStateSpecificIcon = 
			this.stateContentModel.bShowStateSpecificIcon;
	}
	public set showStateSpecificIcon(val: boolean) {
		this.bShowStateSpecificIcon =
			this.stateContentModel.bShowStateSpecificIcon = val;
	}
	public get stateLabel(): string {
		return this.descriptorModel.getDescriptorTextById("stateClick")
			? this.descriptorModel.getDescriptorTextById("stateClick")
			: "Click Here for Additional Required Information";
	}
}
